module.exports = __webpack_public_path__ + "static/3_2_BayesRule_2_NO-affda7e3e5f2a60ebd15d1719e70fc88.svg";